/**
 * @param {Array} versionArr
 * @param {Array} baseArr
 * @return {Boolean}
 */
function compareArr(versionArr, baseArr) {
    // 如果数组为空，返回false
    // 否则根据数组第一位做判断
    if (versionArr[0] && baseArr[0]) {
        if (versionArr[0] !== baseArr[0]) {
            return +versionArr[0] > +baseArr[0]
        }
        // 第一位相等，则递归判断第二位
        return compareArr(versionArr.slice(1), baseArr.slice(1))
    }
    return false
}

function split(str, sign = '.') {
    return str.split(sign)
}

/**
 * 判断版本号是否合法
 *
 * @param {String} version  版本号
 * @return {Boolean}
 */
function legalVersion(version = '') {
    if (version === null) version = ''
    const arr = split(version)
    if (arr.length !== 3) {
        return false
    }
    return /^\d{3,}$/.test(arr.join(''))
}

/**
 * 判断版本号 verison 是否 大于 base
 *
 * @param {String} version  需要做判断的版本号
 * @param {String} base     基准版本号
 * @param {Boolean} isEqValidate     基准版本号
 * @return {Boolean}
 */
function lastestVersion(version, base, isEqValidate = false) {
    // 版本号不合法，则 return false
    if (!legalVersion(version) || !legalVersion(base)) {
        return false
    }
    if (isEqValidate && version === base) {
        return true
    }
    const versionArr = split(version)
    const baseArr = split(base)
    return compareArr(versionArr, baseArr)
}

/**
 * 比较新旧版本号，出错callback(Error)
 * @param value
 * @param oldValue
 * @param callback
 * @param isEqValidate
 */
function compare(value, oldValue, callback, isEqValidate) {
    if (value) {
        if (legalVersion(value)) {
            if (!oldValue || lastestVersion(value, oldValue, isEqValidate)) {
                callback()
            } else {
                callback(new Error(`输入版本号必须大于${isEqValidate ? '或等于' : ''}最新版本`))
            }
        } else {
            callback(new Error('请输入正确格式的版本号，例如： 1.0.0'))
        }
    } else {
        callback(new Error('请输入版本号'));
    }
}

export {
    compare,
    compareArr,
    legalVersion,
    lastestVersion
}
